export const MAX_SHARED_LISTS_FOR_NON_PREMIUM = 1;
export const MAX_SHARED_LISTS_FOR_PREMIUM = 10;